module.exports = __webpack_public_path__ + "img/sadness.4c842972.jpg";